/**
 * ProjectUpdateSection — Clean read-only render. v2
 * Layout: [Project Update title — left] [Status badge — right]
 *         Content body in 1/2/3 CSS columns (set via settings panel).
 * No inline editor. All editing is done in the settings panel.
 */
import React from 'react';

const STATUS_STYLES = {
  'In Progress': { bg: '#dbeafe', text: '#1d4ed8', dot: '#3b82f6' },
  'Completed':   { bg: '#d1fae5', text: '#065f46', dot: '#10b981' },
  'On Hold':     { bg: '#fef3c7', text: '#92400e', dot: '#f59e0b' },
};

export function ProjectUpdateSection({ section, isSelected }) {
  const data = section.data     || {};
  const st   = section.settings || {};

  const status  = data.status     ?? 'In Progress';
  const html    = data.html       ?? '';
  const columns = st.columnsCount ?? 1;

  const bg      = st.backgroundColor || '#f4efe5';
  const textCol = st.textColor        || '#000000';
  const padding = st.padding          || '24px';

  const sty = STATUS_STYLES[status] || STATUS_STYLES['In Progress'];

  return (
    <div style={{ padding, backgroundColor: bg }}>

      {/* ── Header row ────────────────────────────────────────── */}
      <div style={{
        display: 'flex', alignItems: 'center',
        justifyContent: 'space-between', marginBottom: 18,
      }}>
        <div style={{ fontSize: 22, fontWeight: 700, color: textCol, fontFamily: "'Instrument Serif', serif" }}>
          Project Update
        </div>

        {/* Status badge */}
        <span style={{
          display: 'inline-flex', alignItems: 'center', gap: 5,
          padding: '4px 14px', borderRadius: 20, fontSize: 12, fontWeight: 600,
          background: sty.bg, color: sty.text, whiteSpace: 'nowrap',
        }}>
          <span style={{
            width: 7, height: 7, borderRadius: '50%',
            background: sty.dot, display: 'inline-block', flexShrink: 0,
          }} />
          {status}
        </span>
      </div>

      {/* ── Content body ──────────────────────────────────────── */}
      <style>{`
        .pu-content ul { padding-left: 1.5em; list-style-type: disc; margin: 0.4em 0; }
        .pu-content ol { padding-left: 1.5em; list-style-type: decimal; margin: 0.4em 0; }
        .pu-content ul ul { list-style-type: circle; }
        .pu-content li { margin-bottom: 0.25em; }
        .pu-content p  { margin: 0 0 0.4em; }
      `}</style>
      {html ? (
        <div
          className="pu-content"
          style={{
            fontSize: 14, lineHeight: 1.75, color: textCol,
            ...(columns > 1 ? { columnCount: columns, columnGap: '28px' } : {}),
          }}
          dangerouslySetInnerHTML={{ __html: html }}
        />
      ) : (
        <div style={{
          fontSize: 14, color: textCol + '88', fontStyle: 'italic',
        }}>
          {isSelected
            ? 'Add content using the settings panel on the right'
            : 'No content added yet'
          }
        </div>
      )}
    </div>
  );
}
